module.exports = {
  latlng: [51.46874, 6.78446],
  zoom: 15,
  title: 'Unsere Region als Häusermeer',
  introtext:'Wie gut kennen Sie sich wirklich am Niederrhein aus? Erkennen Sie Orte nur anhand der Gebäudeumrisse? Machen Sie das Häuserquiz und ordnen Sie den neun Häuserkarten die richtigen Orte zu. Zu jedem Ausschnitt gibt es einen kleinen Tipp.',
  resultSentences: [
    'Sie waren höchstens mal auf der Durchfahrt hier.',
    'Tourist? Beruflich unterwegs? Sie leben bestimmt nicht hier.',
    'Immerhin kennen Sie ein paar Ecken in der Region.',
    'Nicht schlecht. Sie kennen sich halbwegs aus hier.',
    'Wow! Alles richtig. Sie wirklich ein Experte für die Region.'
  ],
  questions: [
    {
      id: 'NRZ 1',
      lat: 51.503411,
      lng: 6.516717,
      zoom: 15,
      answers: [
        'Wasserburg Anholt',
        'Schloss Oberhausen',
        'Kloster Kamp'
      ],
      correctAnswer: 'Kloster Kamp',
      description: 'Dieser historische Ort ist berühmt für seinen Garten.'
    },
    {
      id: 'NRZ 2',
      lat: 51.584152,
      lng: 6.762397,
      zoom: 15,
      answers: [
        'Bergpark Lohberg',
        'Grugapark Essen',
        'Zeche Zollverein'
      ],
      correctAnswer: 'Bergpark Lohberg',
      description: 'Hier schlug das Herz des Bergbaus besonders laut.'
    },
    {
      id: 'NRZ 3',
      lat: 51.787664,
      lng: 6.314122,
      zoom: 15,
      answers: [
        'Rheinberg-Orsoy',
        'Rees',
        'Grieth'
      ],
      correctAnswer: 'Grieth',
      description: 'Dieses schmucke Dorf liegt direkt am Rhein.'
    },
    {
      id: 'NRZ 4',
      lat: 51.830748,
      lng: 6.242101,
      zoom: 15,
      answers: [
        'Rheinufer in Düsseldorf',
        'Rheinpromenade Emmerich',
        'Innenhafen Duisburg'
      ],
      correctAnswer: 'Rheinpromenade Emmerich',
      description: 'Hier lässt sich das Leben direkt am Wasser genießen.'
    },
    {
      id: 'NRZ 5',
      lat: 51.42705,
      lng: 6.97888,
      zoom: 14,
      answers: [
        'Margarethenhöhe Essen',
        'Dinslaken-Lohberg',
        'Mülheim-Heimaterde'
      ],
      correctAnswer: 'Margarethenhöhe Essen',
      description: 'Diese Siedlung ist besonders berühmt für grüne Gestaltung.'
    },
    {
      id: 'NRZ 6',
      lat: 51.489369,
      lng: 6.878967,
      zoom: 14,
      answers: [
        'Rhein-Ruhr-Zentrum',
        'Centro Oberhausen',
        'Limbecker Platz'
      ],
      correctAnswer: 'Centro Oberhausen',
      description: 'Hier befindet sich einer der größten Food-Courts Europas.'
    },
    {
      id: 'NRZ 7',
      lat: 51.261676,
      lng: 6.734378,
      zoom: 14,
      answers: [
        'Merkur Spiel-Arena',
        'Niederrheinstadion Oberhausen',
        'MSV-Arena Duisburg'
      ],
      correctAnswer: 'Merkur Spiel-Arena',
      description: 'Hier spielt einer der Fußball-Bundesligisten am Rhein.'
    },
    {
      id: 'NRZ 8',
      lat: 51.45003,
      lng: 6.74855,
      zoom: 14,
      answers: [
        'Deltaport in Voerde-Emmelsum',
        'Sechs-Seenplatte in Duisburg',
        'Duisburger Hafen'
      ],
      correctAnswer: 'Duisburger Hafen',
      description: 'Dieser Ort ist für Ruhrgebiet und Niederrhein ein Tor zur Welt.'
    },
    {
      id: 'NRZ 9',
      lat: 51.449341,
      lng: 6.624934,
      zoom: 17,
      answers: [
        'Schloss Moyland',
        'Moerser Schloss',
        'Benrather Schloss'
      ],
      correctAnswer: 'Moerser Schloss',
      description: 'Dieses Schloss ist das älteste erhaltene Bauwerk der Stadt.'
    }
  ]
}